import { newGUID } from './guid.js';
import window from 'global/window';
export var bind = function bind(context, fn, uid) {
    if (!fn.guid) {
        fn.guid = newGUID();
    }
    var bound = function bound() {
        return fn.apply(context, arguments);
    };
    bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
    return bound;
};
export var throttle = function throttle(fn, wait) {
    var last = Date.now();
    var throttled = function throttled() {
        var now = Date.now();
        if (now - last >= wait) {
            fn.apply(void 0, arguments);
            last = now;
        }
    };
    return throttled;
};
export var debounce = function debounce(func, wait, immediate) {
    var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
    var timeout;
    var cancel = function cancel() {
        context.clearTimeout(timeout);
        timeout = null;
    };
    var debounced = function debounced() {
        var self = this;
        var args = arguments;
        var _later = function later() {
            timeout = null;
            _later = null;
            if (!immediate) {
                func.apply(self, args);
            }
        };
        if (!timeout && immediate) {
            func.apply(self, args);
        }
        context.clearTimeout(timeout);
        timeout = context.setTimeout(_later, wait);
    };
    debounced.cancel = cancel;
    return debounced;
};